package br.com.vvrefeicoes.portal.domain.repository

import br.com.vvrefeicoes.portal.domain.model.Permission
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.UserAccount
import br.com.vvrefeicoes.portal.domain.model.UserImportPreview
import br.com.vvrefeicoes.portal.domain.model.UserImportResult
import br.com.vvrefeicoes.portal.domain.model.UserImportRow
import br.com.vvrefeicoes.portal.domain.model.UserProfile

/** Id, nome e perfil (role) de um usuário, usado para popular seletores sem carregar permissões. */
data class UserCandidate(
    val id: String,
    val name: String,
    val role: String,
)

interface UserRepository {
    suspend fun loadUsers(): List<UserAccount>

    suspend fun loadUsersPage(
        page: Int,
        size: Int,
        query: String = "",
        onlyActive: Boolean = false,
    ): UserPage = UserPage(loadUsers(), totalPages = 1)

    /** Id e nome dos usuários (por padrão ativos), para seletores, sem carregar permissões. */
    suspend fun loadUserCandidates(onlyActive: Boolean = true): List<UserCandidate> = loadUsers().map { UserCandidate(it.id, it.fullName, it.role) }

    suspend fun upsert(user: UserAccount)

    suspend fun create(
        user: UserAccount,
        password: String,
    ): String

    suspend fun importUsers(
        profileId: String,
        rows: List<UserImportRow>,
    ): UserImportResult

    suspend fun previewImport(rows: List<UserImportRow>): UserImportPreview

    suspend fun changeStatus(
        userId: String,
        active: Boolean,
    )

    suspend fun changePassword(
        userId: String,
        newPassword: String,
    )

    suspend fun replaceUserPermissions(
        userId: String,
        permissions: Map<String, Set<PermissionAction>>,
    )

    suspend fun loadProfiles(): List<UserProfile>

    suspend fun upsertProfile(profile: UserProfile)

    suspend fun removeProfile(id: String)

    suspend fun loadPermissions(): List<Permission>

    suspend fun upsertPermission(permission: Permission)

    suspend fun removePermission(id: String)
}

data class UserPage(
    val users: List<UserAccount>,
    val totalPages: Int,
)
